import React from 'react';
import { BRAND } from '../../../constants/main';
import { StockModelPageStyledAC } from './AC/StockModelPageStyled.AC';
import { StockModelPageStyledAP } from './AP/StockModelPageStyled.AP';
import { StockModelPageStyledDS } from './DS/StockModelPageStyled.DS';
import { StockModelPageStyledOV } from './OV/StockModelPageStyled.OV';
import { StockModelPageStyled } from './StockModelPageStyled';

import { SC } from '../../../styles/theme';

export type StockModelPageProps = SC & {};

const StockTrimPage = (props: StockModelPageProps) => {
    if (BRAND === 'AC') return <StockModelPageStyledAC {...props} />;
    if (BRAND === 'OV') return <StockModelPageStyledOV {...props} />;
    if (BRAND === 'AP') return <StockModelPageStyledAP {...props} />;
    if (BRAND === 'DS') return <StockModelPageStyledDS {...props} />;
    return <StockModelPageStyled {...props} />;
};

export default StockTrimPage;
